import React from 'react'

const Linux = () => {
  return (
    <div>
        {/* collapseFourtyOne */}
        <div className="accordion-item mb-2">
            <h2 className="accordion-header" id="headingFourtyOne">
                <button className="accordion-button collapsed d-flex justify-content-between align-items-center border py-2 fw-bold" type="button" data-bs-toggle="collapse" data-bs-target="#collapseFourtyOne" aria-expanded="false" aria-controls="collapseFourtyOne">
                    Linux
                    <span className="toggle-icon ms-auto"></span>
                </button>
            </h2>
            <div id="collapseFourtyOne" className="accordion-collapse collapse" aria-labelledby="headingFourtyOne" data-bs-parent="#accordionCourses">
                <div className="accordion-body overflow-auto" style={{ maxHeight: '200px' }}>
                    <ul>
                        <li>Introduction</li>
                        <li>Basic & Advanced Commands</li>
                        <li>Kernel</li>
                        <li>Namespaces</li>
                        <li>Process & Threads</li>
                        <li>File System</li>
                        <li>Shell Scripting</li>
                        <li>Root</li>
                        <li>User & Groups</li>
                    </ul>

                </div>
            </div>
        </div>

    </div>
  )
}

export default Linux